import evaluateSafeLinkService from '../services/evaluateSafeLinkService';

interface SafeLinkQueueEntry {
    url: string;
    promise: null | Promise<string>;
    resolve: null | ((value?: string | PromiseLike<string>) => void);
}

const safeLinkQueue: SafeLinkQueueEntry[] = [];
const resultCache: Map<string, string | null> = new Map();
let processQueueTimeout;

export default async function evaluateSafeLink(safeLinkUrl: string): Promise<string> {
    // return null if safeLinkUrl is null or empty
    if (!safeLinkUrl || !safeLinkUrl.length) {
        return null;
    }

    // return if cache has the result
    if (resultCache.has(safeLinkUrl)) {
        return resultCache.get(safeLinkUrl);
    }

    // if the same URL is already in queue
    // return the promise of that entry
    const existingEntries = safeLinkQueue.filter(entry => entry.url === safeLinkUrl);
    if (existingEntries?.length > 0) {
        return existingEntries[0].promise;
    }

    // create a new entry
    const newQueueEntry = {
        url: safeLinkUrl,
        promise: null,
        resolve: null,
    };

    // tslint:disable-next-line:promise-must-complete
    newQueueEntry.promise = new Promise<string>(resolve => {
        newQueueEntry.resolve = resolve;
    });
    safeLinkQueue.push(newQueueEntry);

    if (processQueueTimeout) {
        clearTimeout(processQueueTimeout);
    }
    processQueueTimeout = setTimeout(processQueue, 1000);

    return newQueueEntry.promise;
}

export async function evaluateSafeLinks(safeLinkUrls: string[]): Promise<string[]> {
    return await Promise.all(safeLinkUrls.map(url => evaluateSafeLink(url)));
}

async function processQueue() {
    if (safeLinkQueue.length > 0) {
        // make a copy of the queue
        const currentQueue = safeLinkQueue.splice(0, safeLinkQueue.length);
        const safeLinkUrls = currentQueue.map(entry => entry.url);
        const results = await evaluateSafeLinkService(safeLinkUrls);

        results.map((result, index) => {
            const { url, resolve } = currentQueue[index];
            resultCache.set(url, result);
            resolve(result);
        });
    }
}
